import { useRef } from 'react';

import { Heading2, Paragraph2 } from 'inpock-ui-react';

import { useOutsideClick } from '@/hooks';

import * as S from './styled';

interface DialogProps {
  onHide: React.Dispatch<React.SetStateAction<boolean>> | ((v: boolean) => void);
  preventHide?: boolean;
  children?: React.ReactNode;
}

export function Dialog(props: DialogProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useOutsideClick(containerRef, () => {
    if (props.preventHide) return;
    props.onHide(false);
  });

  return (
    <S.Wrapper>
      <S.Container ref={containerRef}>{props.children}</S.Container>
    </S.Wrapper>
  );
}

export function PostcodeDialog(props: DialogProps) {
  return (
    <S.PriorWrapper onClick={() => props.onHide(false)}>
      <S.PostcodeContainer>{props.children}</S.PostcodeContainer>
    </S.PriorWrapper>
  );
}

export function DialogHeader({ title, subTitle }: { title: string; subTitle?: string }) {
  return (
    <header>
      <Heading2 className="mb-8">{title}</Heading2>
      {subTitle && (
        <Paragraph2 color="gray400" fontWeight="regular">
          {subTitle}
        </Paragraph2>
      )}
    </header>
  );
}
